import React  from 'react';
import { useConnect } from '@lore/query-connect';
import Tooltip from '../../../components/Tooltip';

export default function Projects(props) {
  const { site } = props;

  const completed = useConnect('project.find', {
    where: {
      eager: {
        $where: {
          siteId: site.id,
          completed: true
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  const cancelled = useConnect('project.find', {
    where: {
      eager: {
        $where: {
          siteId: site.id,
          cancelled: true
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  const other = useConnect('project.find', {
    where: {
      eager: {
        $where: {
          siteId: site.id,
          completed: false,
          cancelled: false
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  const completedEvents = useConnect('event.find', {
    where: {
      eager: {
        $where: {
          siteId: site.id,
          completed: true
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  const cancelledEvents = useConnect('event.find', {
    where: {
      eager: {
        $where: {
          siteId: site.id,
          cancelled: true
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  const otherEvents = useConnect('event.find', {
    where: {
      eager: {
        $where: {
          siteId: site.id,
          completed: false,
          cancelled: false
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  return (
    <div className="whitespace-nowrap space-x-2">
      <span className="inline-flex">
        <Tooltip tooltip="Cancelled projects/events" icon={false}>
          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">
            {cancelled.meta?.totalCount} / {cancelledEvents.meta?.totalCount}
          </span>
        </Tooltip>
      </span>
      <span className="inline-flex">
        <Tooltip tooltip="Unclosed projects/events" icon={false}>
          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800">
            {other.meta?.totalCount} / {otherEvents.meta?.totalCount}
          </span>
        </Tooltip>
      </span>
      <span className="inline-flex">
        <Tooltip tooltip="Completed projects/events" icon={false}>
          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
            {completed.meta?.totalCount} / {completedEvents.meta?.totalCount}
          </span>
        </Tooltip>
      </span>
    </div>
  );
}
